module.exports = __webpack_public_path__ + "img/fruits-veg-food.9bc8f838.jpg";